import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

/** Formulário de perfil do candidato (nome, contacto, localização, título, sobre). */
export const ProfileForm = ({ profile, setProfile, meta, onSubmit }) => (
  <form onSubmit={onSubmit} className="bg-white rounded-2xl border border-black/5 p-6 sm:p-8 space-y-4">
    <div>
      <Label className="mb-1.5 block">Nome</Label>
      <Input data-testid="profile-name-input" value={profile.name}
        onChange={(e) => setProfile({ ...profile, name: e.target.value })} />
    </div>
    <div>
      <Label className="mb-1.5 block">Telefone</Label>
      <Input data-testid="profile-phone-input" value={profile.phone}
        onChange={(e) => setProfile({ ...profile, phone: e.target.value })} placeholder="9xxxxxxxx" />
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <Label className="mb-1.5 block">Distrito</Label>
        <Select value={profile.district || ""}
          onValueChange={(v) => setProfile({ ...profile, district: v, concelho: "" })}>
          <SelectTrigger data-testid="profile-district-input"><SelectValue placeholder="Escolhe o distrito" /></SelectTrigger>
          <SelectContent className="max-h-72">
            {Object.keys(meta?.districts || {}).map((d) => <SelectItem key={d} value={d}>{d}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="mb-1.5 block">Concelho</Label>
        <Select value={profile.concelho || ""} onValueChange={(v) => setProfile({ ...profile, concelho: v })}
          disabled={!profile.district || !meta}>
          <SelectTrigger data-testid="profile-concelho-input"><SelectValue placeholder="Escolhe o concelho" /></SelectTrigger>
          <SelectContent className="max-h-72">
            {(meta?.districts?.[profile.district] || []).map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
        <p className="text-[11px] text-slate-400 mt-1.5">Usado no filtro de vagas por distância.</p>
      </div>
    </div>
    <div>
      <Label className="mb-1.5 block">Título profissional</Label>
      <Input data-testid="profile-headline-input" value={profile.headline}
        onChange={(e) => setProfile({ ...profile, headline: e.target.value })}
        placeholder="Ex.: Empregado de mesa com 3 anos de experiência" />
    </div>
    <div>
      <Label className="mb-1.5 block">Sobre mim</Label>
      <Textarea data-testid="profile-about-input" rows={4} value={profile.about}
        onChange={(e) => setProfile({ ...profile, about: e.target.value })} />
    </div>
    <Button data-testid="profile-save-btn" type="submit" className="rounded-full bg-slate-900 hover:bg-slate-800">
      Guardar perfil
    </Button>
  </form>
);
